<template>
  <modal-provider name="welcome-bonus-modal" :width="500" @before-open="beforeOpen">
    <div class="modal--welcome">
      <img class="bg-image" src="/img/tree-branch.png" alt="tree branch">
      <div class="modal__slide-line slide-line">
        <template v-if="hasWelcomeBonus">
          <span class="slide-line__text">{{ $t('welcome_bonus_slide_success_text') }}<span>/</span></span>
          <span class="slide-line__text">{{ $t('welcome_bonus_slide_success_text') }}<span>/</span></span>
          <span class="slide-line__text">{{ $t('welcome_bonus_slide_success_text') }}<span>/</span></span>
        </template>
        <template v-else>
          <span class="slide-line__text">{{ $t('welcome_bonus_slide_text') }}<span>/</span></span>
          <span class="slide-line__text">{{ $t('welcome_bonus_slide_text') }}<span>/</span></span>
          <span class="slide-line__text">{{ $t('welcome_bonus_slide_text') }}<span>/</span></span>
        </template>
      </div>
      <div class="modal__content">
        <template v-if="isAuth">
          <span class="modal__text"
          >{{ $t('welcome_bonus_hello_text') }}{{ userData.name ? ', ' + userData.name + '!' : '!' }}</span
          >
          <span
            v-if="hasWelcomeBonus"
            class="modal__text-additional"
            v-html="$t('welcome_bonus_success_text')"
          ></span>
          <span v-else class="modal__text-additional" v-html="$t('welcome_bonus_dismiss_text')">}</span>
        </template>
        <template v-else>
          <span class="modal__text" v-html="$t('welcome_bonus_first_buy_text')"></span>
          <div class="modal__form-wrap">
            <span class="modal__form-label" v-html="$t('welcome_bonus_form_label_text')"></span>
            <AuthPhone is-ajax-auth is-hidden-labels :remember-field="false" />
          </div>
        </template>
      </div>
    </div>
  </modal-provider>
</template>

<script>
import { mapState } from 'vuex'
import AuthPhone from '../../components/auth/AuthPhone'
export default {
  name: 'WelcomeBonusModal',
  props: {
    nextModalShowing: {
      type: Number,
      required: true
    },
    delayShowing: {
      type: Number,
      required: true
    }
  },
  components: {
    AuthPhone
  },
  computed: {
    ...mapState({
      isAuth: state => state.user.auth,
      hasWelcomeBonus: state => state.user.hasWelcomeBonus,
      userData: state => state.user.user_data
    })
  },
  methods: {
    hideModal () {
      this.$modal.hide('welcome-bonus-modal')
    },
    beforeOpen () {
      localStorage.setItem(
        'nextWelcomeBonusModal',
        this.nextModalShowing.toString()
      )
    },
    canDisplay () {
      const currentTime = new Date().getTime() / 1000
      const welcomeBonusShowingTime =
        localStorage.getItem('nextWelcomeBonusModal') || 0

      if (currentTime <= welcomeBonusShowingTime) { return false }

      const popupDisplayTime = JSON.parse(localStorage.getItem('modalsDisplayTimestamp') ?? '{}')
      if (((popupDisplayTime['welcome-friends-modal'] ?? 0) / 100) + 5 * 60 > currentTime) { return false }
      return true
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.canDisplay()) {
        this.$modal.show('welcome-bonus-modal')
      }
    }, this.delayShowing)
  }
}
</script>

<style scoped lang="sass">

.modal--welcome
  position: relative
  padding: 220px 20px 20px
  background: linear-gradient(164.51deg, #E0EEFF 0%, #FFFFFF 103.64%)
  &::before
    content: ''
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    background: url('/img/welcome-bonus-shum.png')

  &:focus
    outline: none

.bg-image
  position: absolute
  right: 0
  top: 0
  max-width: 85%

::v-deep
  .modal-body,.modal-heading
    padding:0
  .modal__close
    background: rgba(0, 0, 0, 0.11)
    padding: 16px
    border-radius: 50%
    z-index: 10
    opacity: 1
    right: 15px
    top: 15px

    &:hover
      background: rgba(0, 0, 0, 0.21)

    &:before,
    &:after
      top: 50%
      left: 50%
      background: #fff

    &:before
      transform: translate(-50%, -50%) rotate(45deg)

    &:after
      transform: translate(-50%, -50%) rotate(-45deg)

.modal__text
  display: block
  text-align: center
  font-size: 22px
  font-weight: 500
  color: #272727

.modal__form-wrap
  margin: 60px 0 0

.modal__form-label,
.modal__text-additional
  display: block
  text-align: center
  font-size: 16px
  font-weight: 400
  color: $text-color
  margin: 0 0 40px

.modal__text-additional
  max-width: 350px
  margin: 30px auto 90px

// slide-line
.slide-line
  position: absolute
  left: -5%
  right: -5%
  top: 80px
  display: flex
  flex-flow: row nowrap
  align-items: center
  width: 110%
  overflow: hidden
  pointer-events: none
  padding: 30px 0
  background-color: #FF2F00
  transform: rotate(-4.43deg)

.slide-line__text
  color: #fff
  flex-shrink: 0
  font-size: 44px
  font-weight: 700
  line-height: 110%
  text-transform: uppercase
  animation: marquee-to-left 2s infinite linear

  span
    padding: 0 20px

@keyframes marquee-to-left
  0%
    transform: translate(0, 0)

  100%
    transform: translate(-100%, 0)
</style>
